import { createFeature, createFeatureSelector, createSelector } from "@ngrx/store";
import { CartAdapter, CartState } from "./cart.entity";


export const CartFeatureSelector = createFeatureSelector<CartState>('cart');



export const {
  selectIds: SelectCartIDs,
  selectEntities: SelectCartItemsEntity,
  selectAll: SelectCartItems,
  selectTotal: SelectCartTotalItems,
} = CartAdapter.getSelectors(CartFeatureSelector);


export const SelectCartInitializer = createSelector(
  CartFeatureSelector,
  state => state.initialized
)

export const SelectCart = createSelector(CartFeatureSelector,
  state => state.cart
)

export const SelectCartQuantity = createSelector(
  SelectCartItems,
  (items) => items.reduce((sum, item) => sum + item.quantity, 0)
);

export const SelectCartPrice = createSelector(
  SelectCart,
  state => state.total
)

export const SelectCartGetSuccessMessage = createSelector(
  CartFeatureSelector,
  state => state.getCartSuccess
)

export const SelectCartGetFailureMessage = createSelector(
  CartFeatureSelector,
  state => state.getCartFailure
)

export const SelectCartUpdateSuccessMessage = createSelector(
  CartFeatureSelector,
  state => state.updateCartSuccess
)

export const SelectCartUpdateFailureMessage = createSelector(
  CartFeatureSelector,
  state => state.updateCartFailure
)